import React, { useState, useEffect, useCallback } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Select from "react-select";
import Pagination from "react-js-pagination";
import { itemCount } from "Constants";
import NoContent, { NO_SESSIONSCANED } from "NoContent";
import _ from "lodash";
// IMPORT LANGUAGE
import LocaleStrings from "Languages";
// IMPORT ACTION
import {
  fetchSessionListWithEventId,
  fetchSessionScanningAttendees,
} from "SessionanalyticActions";
import SessionScannedListItem from "./session-scanned-list-item";
import ExportSessionScanningExcelBtn from "./download-session-scanned-excel";

function TableContentSessionScanningList(props) {
  let options = [];
  let { eventSessionList, sessionScannedList } = props;
  const [selectedOption, setSelectedOption] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);

  /* Create Option For Auto select */
  if (!_.isEmpty(eventSessionList)) {
    eventSessionList.forEach((item, index) => {
      let obj = {
        label: `${item.title} (${item.acount})`,
        value: item.sessionid,
      };
      options.push(obj);
    });
  }

  const _handleChange = (selectedOption) => {
    if (!_.isEmpty(selectedOption)) {
      setSelectedOption(selectedOption);
      props.fetchSessionScanningAttendees(
        props.session,
        0,
        0,
        selectedOption.value,
        (response) => {}
      );
    } else {
      setSelectedOption(null);
      props.fetchSessionScanningAttendees(
        props.session,
        0,
        0,
        "",
        (response) => {}
      );
    }
  };

  // function paginationCallback(c) {

  // }
  const paginationCallback = useCallback(
    (newPageNumber) => {
      /* Admin Panel Session Scanning Analytics / Attendence List */
      setPageNumber(newPageNumber);
      props.fetchSessionScanningAttendees(
        props.session,
        newPageNumber,
        0,
        "", // sessionId
        (response) => {}
      );
    },
    [] // Tells React to memoize regardless of arguments.
  );

  /* Render table list here */
  const renderSessionScannedTablelist = () => {
    let pageDataLength = sessionScannedList
      ? sessionScannedList.data
        ? sessionScannedList.data.length
        : ""
      : "";

    return _.map(sessionScannedList.data, (appUser, index) => {
      return (
        <SessionScannedListItem
          key={index}
          appUser={appUser}
          position={index}
          // pagination={paginationCallback}
          pageDataLength={pageDataLength}
          currentPage={pageNumber}
        />
      );
    });
  };

  /* Export CSV */
  const exportAttendence = (JSONData, ShowLabel) => {
    JSONToCSVConvertor(JSONData, ShowLabel);
  };

  const JSONToCSVConvertor = (JSONData, ShowLabel) => {
    var XLSX = require("xlsx");
    /* Create a new empty workbook, then add the worksheet */
    let wb = XLSX.utils.book_new();

    _.map(JSONData, (item, index) => {
      /* Create a worksheet */
      var ws = XLSX.utils.json_to_sheet(item);

      index = _.replace(index, "  ", "");
      var sheetName = index.replace(/[\/\\:\[\]*?]/g, "_"); // Sheet name cannot contain ': \ / ? * [ ]' so replacing with '_' and also can not contain more than 31 chars

      sheetName = sheetName.replace(
        /[`~!@#$%^&*()_|+\-=?;:'",<>\{\}\[\]\\\/]/gi,
        "_"
      );
      /* 
        Old code 
        if (sheetName.length > 30) {
          sheetName = sheetName.substr(0, 26) + "..S" + cnt;
        }
      */
      // XLSX.utils.book_append_sheet(wb, ws1, "F2(149426)");

      XLSX.utils.book_append_sheet(wb, ws, sheetName);
    });
    /* Generate xlsx files */
    XLSX.writeFile(wb, "attendence.xlsx");
  };

  useEffect(() => {
    props.fetchSessionListWithEventId(props.session, (response) => {
      /* Fetch session list with evenrid */
    });

    /* Admin Panel Session Scanning Analytics / Attendence List */
    props.fetchSessionScanningAttendees(
      props.session,
      0,
      0,
      "",
      (response) => {}
    );

    return () => {};
  }, []);

  return (
    <div className="social-content">
      <div className="tableHeaderSection">
        <div className="row">
          <div className="col-md-6">
            <p className="analytics-chart-header">
              {LocaleStrings.analytics_sessions_table_header_text4}
            </p>
            <p className="analytics-chart-subheader">
              {LocaleStrings.analytics_sessions_table_subheader_text4}
            </p>
          </div>
          <div className="col-md-6">
            <div className="row">
              <div className="col-md-4" align="right">
                <ExportSessionScanningExcelBtn
                  JSONToCSVConvertor={exportAttendence}
                  selectedOption={selectedOption}
                />
              </div>
              <div className="col-md-8">
                <Select
                  className="react-multi-select-custom-css"
                  value={selectedOption}
                  onChange={_handleChange}
                  options={options}
                  closeMenuOnSelect={true}
                  isClearable
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <table className="table">
        <thead className="analyticsTable">
          <tr>
            <th>{LocaleStrings.analytics_sessions_table_thead_text14}</th>
            <th>
              {LocaleStrings.analytics_sessions_table_thead_text15}{" "}
              {!_.isEmpty(selectedOption)
                ? sessionScannedList && "(" + sessionScannedList.count + ")"
                : ""}
            </th>
            <th>{LocaleStrings.analytics_sessions_table_thead_text16}</th>
            <th>{LocaleStrings.analytics_sessions_table_thead_text17}</th>
          </tr>
        </thead>
        <tbody className="tbody-background">
          {sessionScannedList &&
          sessionScannedList.data &&
          sessionScannedList.data.length > 0 ? (
            renderSessionScannedTablelist()
          ) : (
            <tr>
              <td colSpan="4" className="py-5">
                <NoContent contentType={NO_SESSIONSCANED} connectFor="table" />
              </td>
            </tr>
          )}
        </tbody>
      </table>
      {sessionScannedList && sessionScannedList.count > itemCount ? (
        <Pagination
          activePage={pageNumber}
          itemsCountPerPage={itemCount}
          totalItemsCount={props.sessionScannedList.count}
          pageRangeDisplayed={10}
          onChange={paginationCallback}
          style={{ float: "right" }}
        />
      ) : null}
    </div>
  );
}

function mapStateToProps(state) {
  return {
    session: state.session,
    eventSessionList: state.eventSessionList,
    sessionScannedList: state.sessionScannedList,
  };
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      fetchSessionListWithEventId, // Fetch session titles
      fetchSessionScanningAttendees, // Admin Panel Session Scanning Analytics / Attendence List (paginated)
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TableContentSessionScanningList);
